import Vue from 'vue'
import axios from 'axios'

const initState = {}

export default {
  namespaced: true,
  state: Vue.util.extend({}, initState),
  mutations: {},
  actions: {
    getPlace({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`places/${params.placeRecordId}`, { params })
          .then((res) => resolve(res.data.data))
          .catch((err) => reject(err))
      })
    },
    syncPlace({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('places', params)
          .then((res) => resolve(res.data.place))
          .catch((err) => reject(err))
      })
    },
    distributePlace({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`places/${params.placeRecordId}/distribute`, params)
          .then((res) => resolve(res.data.place))
          .catch((err) => reject(err))
      })
    }
  },
  getters: {}
}